export const getPending = (state) => state.valorisations.pending;
export const getRunning = (state) => state.valorisations.running;
export const getFinished = (state) => state.valorisations.finished;
